import { render, staticRenderFns } from "./PosicionesFormComponent.vue?vue&type=template&id=04e36b9e&"
import script from "./PosicionesFormComponent.vue?vue&type=script&lang=js&"
export * from "./PosicionesFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports